export const numberedStepsListMock = {
  heading: "Jak wykonać badania na bezsenność w domu?",
  steps: [
    {
      title: "Zaplanuj badania",
      description: "Wybierz badania, datę i adres pobrania.",
    },
    {
      title: "Zbadaj się u Siebie",
      description: "Kiedy Ci wygodnie, wtedy gdy tego potrzebujesz.",
    },
    {
      title: "Skonsultuj wyniki online",
      description: "Porozmawiaj ze specjalistą medycznym uPacjenta.",
      annotation: "Wybierz Pakiet Badań, a konsultację zyskasz gratis. Po zakupie otrzymasz maila ze szczegółami.",
    },
    {
      title: "Ciesz się lepszym zdrowiem",
      description: "Zastosuj porady eksperta i obserwuj poprawę samopoczucia.",
    },
  ],
};
